// extracted by mini-css-extract-plugin
export default {"aRight":"Shop_aRight__nxvKL","cPointer":"Shop_cPointer__428r5","header":"Shop_header__kyTyS","shopProjectCard":"Shop_shopProjectCard__zlh6w"};